const AlumniView = () => {
  return <div>Alumni View</div>;
};

export default AlumniView;
